import { Minus, Plus } from 'lucide-react'

import { cn } from '@/lib/utils'

import { Button } from './Button'

interface ExpandButtonProps {
  /** Current expanded state */
  isExpanded: boolean
  /** Click handler */
  onClick: () => void
  /** Text shown when expanded */
  expandedText: string
  /** Text shown when collapsed */
  collapsedText: string
  /** Additional classes */
  className?: string
}

/**
 * ExpandButton - Toggle button for expand/collapse sections
 *
 * Uses shadcn/ui Button with expand variant.
 * Uses Plus/Minus icons from lucide-react.
 */
export function ExpandButton({
  isExpanded,
  onClick,
  expandedText,
  collapsedText,
  className,
}: ExpandButtonProps) {
  return (
    <div className={cn('flex items-center justify-center md:mb-0 mb-5', className)}>
      <Button
        type="button"
        variant="expand"
        size="expand"
        onClick={onClick}
      >
        {isExpanded ? (
          <Minus className="h-5 w-5" aria-hidden="true" />
        ) : (
          <Plus className="h-5 w-5" aria-hidden="true" />
        )}
        <span>{isExpanded ? expandedText : collapsedText}</span>
      </Button>
    </div>
  )
}

ExpandButton.displayName = 'ExpandButton'
